var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_683_29344)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_683_29344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8716 5.21169C15.3002 5.21169 14.8633 4.77547 14.8633 4.20503V1.92328C14.8633 1.35284 15.3002 0.916626 15.8716 0.916626C16.443 0.916626 16.8799 1.35284 16.8799 1.92328V4.20503C16.8799 4.74192 16.4094 5.21169 15.8716 5.21169Z",
    fill: "#000E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9986 5.21169C10.4272 5.21169 9.99023 4.77547 9.99023 4.20503V1.92328C9.99023 1.35284 10.4272 0.916626 10.9986 0.916626C11.57 0.916626 12.0069 1.35284 12.0069 1.92328V4.20503C12.0069 4.74192 11.57 5.21169 10.9986 5.21169Z",
    fill: "#000E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15872 5.21169C5.58733 5.21169 5.15039 4.77547 5.15039 4.20503V1.92328C5.15039 1.35284 5.58733 0.916626 6.15872 0.916626C6.73011 0.916626 7.16706 1.35284 7.16706 1.92328V4.20503C7.16706 4.74192 6.6965 5.21169 6.15872 5.21169Z",
    fill: "#000E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.916016 8.29883V20.1103C0.916016 20.6807 1.35296 21.1169 1.92435 21.1169H20.0743C20.6457 21.1169 21.0827 20.6807 21.0827 20.1103V8.29883H0.916016Z",
    fill: "#000E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0743 2.39307H18.1249H17.856H17.3855V4.17149C17.3855 5.01037 16.7132 5.68147 15.873 5.68147C15.0327 5.68147 14.3605 5.01037 14.3605 4.17149V2.39307H12.5118V4.17149C12.5118 5.01037 11.8396 5.68147 10.9993 5.68147C10.1591 5.68147 9.48685 5.01037 9.48685 4.17149V2.39307H7.63824V4.17149C7.63824 5.01037 6.96602 5.68147 6.12574 5.68147C5.28546 5.68147 4.61324 5.01037 4.61324 4.17149V2.39307H4.14268H1.92435C1.35296 2.39307 0.916016 2.82928 0.916016 3.39972V7.29212H21.0827V3.39972C21.0827 2.86284 20.6457 2.39307 20.0743 2.39307Z",
    fill: "#000E13"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_683_29344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_683_29344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1667,
    height: 20.1667,
    fill: "white",
    transform: "translate(0.916016 0.916626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.df961f0d7ec5e8999cb0a15321001701.svg";
export { ForwardRef as ReactComponent };